export default __webpack_public_path__ + "static/media/oldbanner1.5a0f3fa3.png";